import axios from "axios";
import apihostname from "./apihostname";

class AuthService {
  login(email, passwd) {
    return axios
      .post(apihostname + "/users/authenticate", {
        email,
        passwd,
      })
      .then((response) => {
        if (response.data.token) {
          sessionStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("ca_pass");
  }

  register(username, email, password) {
    return axios.post(apihostname + "/signup", {
      username,
      email,
      password,
    });
  }

  getCurrentUser() {
    return JSON.parse(sessionStorage.getItem("user"));
  }
}

export default new AuthService();
